"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Markers = function Markers(props) {
  var list = props.list,
    duration = props.duration;
  var getLeft = function getLeft(marker) {
    return marker.time / duration * 100;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, list.map(function (marker, index) {
    var left = getLeft(marker);
    var width = index === list.length - 1 ? 100 - left : getLeft(list[index + 1]) - left;
    return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      key: marker.time,
      title: marker.label,
      tippyProps: {
        followCursor: 'horizontal'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].chapter,
      style: {
        left: "".concat(left, "%"),
        width: "".concat(width, "%")
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].marker
    })));
  }));
};
Markers.propTypes = {
  list: _propTypes["default"].array,
  duration: _propTypes["default"].number
};
var _default = exports["default"] = Markers;